import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function OpeningHook() {
  return <section className="w-full bg-blush-soft py-20 md:py-28" data-id="element-206">
      <div className="max-w-4xl mx-auto px-6 md:px-8" data-id="element-207">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-center" data-id="element-208">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white shadow-sm mb-8" data-id="element-209">
            <QuoteIcon className="w-6 h-6 text-blush-deep" data-id="element-210" />
          </div>
          <p className="font-serif italic text-2xl md:text-3xl text-ink leading-relaxed" data-id="element-211">
            Has hecho todo lo que te dijeron. Comes orgánico, haces ejercicio y
            tomas todas las vitaminas. Pero cada mes, la prueba sigue siendo
            negativa. Te han dicho que es "infertilidad inexplicada", pero la
            realidad es que tu cuerpo está rodeado de ruido químico que le
            ordena no reproducirse.
          </p>
          <div className="mt-10 mx-auto w-16 h-px bg-blush-deep/40" aria-hidden="true" data-id="element-212" />
        </motion.div>
      </div>
    </section>;
}